module.exports = __webpack_public_path__ + "static/media/drop.42f8bee0.svg";